import { Button, Fade, Grid, Tooltip, Typography } from "@mui/material";
import IconsContainer from "src/components/icons/others/IconsContainer";
import PropTypes from "prop-types";
import MySkeleton from "src/components/layout/MySkeleton";
import { kestoString } from "src/components/js/statics1";
import { useKeikkaData } from "src/context/KeikkaDataContext";

export default function AikaRow(props) {
  const { keikkaData } = useKeikkaData();
  const fadeTime = 500;
  const isError =
    keikkaData.auth.edit && keikkaData.tila.keikkaTilaId < 5 && keikkaData.aikaError() != null;

  const styles = {
    div: {
      padding: isError ? "10px" : "0px",
      transition: "all 0.6s ease-in-out",
    },
  };

  return (
    <div style={styles.div}>
      <Tooltip
        disableInteractive
        title={isError ? keikkaData.aikaError() : ""}
        placement="top-end"
        arrow>
        <Button
          variant={keikkaData.auth.edit && keikkaData.aikaError() ? "outlined" : "text"}
          sx={{ minHeight: "40px", margin: 0, padding: 0 }}
          onClick={props.onClick}
          fullWidth
          aria-label="Muokkaa aikaa">
          <Grid container className="stepRow" sx={{ width: "100%" }}>
            <Grid size={{ xs: 3 }} sx={{ textAlign: "right" }}>
              <Typography
                variant="h6"
                sx={{ paddingRight: "5px" }}
                color="primary"
                className="fixPrint">
                Aika:
              </Typography>
            </Grid>
            {keikkaData.keikkaId === 0 || keikkaData.isLoading ? (
              <MySkeleton width="70%" height="35px" />
            ) : (
              <>
                <Fade in={true} timeout={fadeTime}>
                  <Grid size={{ xs: 8 }} sx={{ paddingTop: "5px" }}>
                    <Typography
                      color={
                        keikkaData.pumppu.pumppuAikaStringLong || keikkaData.pumppu.ehdotaAikaa
                          ? "primary"
                          : "warning.main"
                      }
                      align="left"
                      className="fixPrint"
                      sx={{ transition: "all 1.1s ease-in-out" }}>
                      {getKeikkaAikaText()}
                    </Typography>
                  </Grid>
                </Fade>
                <Fade in={true} timeout={fadeTime}>
                  <Grid size={{ xs: 1 }} className="frontPageEditIcon">
                    <IconsContainer
                      showWarning={keikkaData.aikaError() != null}
                      showEdit={keikkaData.auth.edit}
                      editOpacity={0.5}
                    />
                  </Grid>
                </Fade>
              </>
            )}
          </Grid>
        </Button>
      </Tooltip>
    </div>
  );

  function getKeikkaAikaText() {
    if (!keikkaData.pumppu) return "";
    if (!keikkaData.auth.read) return "Ei oikeuksia";
    // jos ehdota aikaa
    kestoString(keikkaData.pumppu.kesto);
    if (keikkaData.pumppu.ehdotaAikaa) {
      const arvioH = keikkaData.pumppu.pumppuKesto / 60;
      // round to 0.5
      const arvioH2 = (
        <small>
          <i>~{Math.round(arvioH * 2) / 2}h</i>
        </small>
      );
      if (keikkaData.auth.isKeikkaAdmin) {
        return <>Ehdota aikaa {arvioH2}</>;
      } else {
        return <>Sovitaan myöhemmin {arvioH2}</>;
      }
    }

    // jos ei virhettä
    const txt = keikkaData.pumppu.pumppuAikaStringLong;
    if (txt) return txt;

    // jos virhe
    if (keikkaData.auth.edit) return "Valitse toimitusaika";
    return "Toimitusaika puuttuu";
  }
}
AikaRow.propTypes = {
  onClick: PropTypes.func,
};
